<template>
    <base-alert type="warning" class="mb-4" v-if="hasWarnings">
        <i class="fas fa-exclamation-triangle mr-3"></i> {{ notice }}
        <a href="#" @click.prevent="openWarnings">{{ $t('warnings.notice-link') }}</a>.
    </base-alert>
</template>

<script>
    export default {

        data() {
            return {
                endpoint: '/astral/api/front/dashboard/warnings/count',
                warnings: 0,
            }
        },

        created() {
            axios.get(this.endpoint).then(resp => {          
                this.warnings = resp.data.data
            })
        },

        computed: {

            hasWarnings() {
                return this.warnings > 0
            },

            notice() {
                return this.$t('warnings.notice', { count: this.warnings })
            }
        },

        watch: {
            hasWarnings(val) {
                if (val) {
                    this.$emit("show")
                }
            }
        },

        methods: {

            openWarnings() {
                this.$router.push({ name: 'dashboard-instructor-warnings' });
            }
        }
    }
</script>

<style scoped>

    a {
        color: #fff;
        text-decoration: underline;
    }

</style>